import request from "@/core/utils/request";

export async function checkLoginIn(params) {
  return request("/api-common-base/sms/validCode/check", {
    method: "post",
    data: params
  });
}

export async function queryRecommendCarList() {
  return request("/api/search/queryRecommendCarList");
}
